import { ChangeDetectionStrategy, Component, HostBinding, Input, Optional } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { isEskoHostname } from '@shared/utilities/branding.utilities';

@Component({
  selector: 'brand-wordmark',
  standalone: true,
  templateUrl: './brand-wordmark.component.html',
  styleUrls: ['./brand-wordmark.component.scss'],
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandWordmark {
  @Input()
  @HostBinding('class')
  class: string;

  @Input()
  color: string = null;

  isEsko = this.ss?.branding.value ? this.ss?.branding.value?.name === 'Esko' : isEskoHostname();

  constructor(@Optional() readonly ss: SurveyStore) {}
}
